@let isInDeviceContext = inDeviceContext() != null;
<sb-table-wrapper headline="{{'lang.globals.playoutDescriptor' | translate}}" [itemsData]="playoutDescriptors"
                  [isInModalContext]="isInModalContext" [hideSearch]="true" [isInIntegratedContext]="isInDeviceContext"
                  [options]="options" (optionsChange)="requestDebounced($event)"
                  [loading]="loading()"
                  [itemName]="'playoutDescriptors'">
  <!------------------------------

       Header More

 ------------------------------->
  <div header-more>
    <div class="tw-flex tw-items-center tw-gap-2">
      <!--
      <sb-toggle class="mr-2" [toggleLabel]="'Aggregation'" [checked]="useAggregated"
                 (valueChange)="changeAggregationUsage($event)"></sb-toggle>
      -->
      <sb-threeway-toggle-button
        id="Bookable"
        [model]="productive === null? -1 : productive? 1: 0"
        (modelChange)="setProductive($event)"
      >
        {{ 'lang.globals.productive' |translate }}
      </sb-threeway-toggle-button>
      <div>
        <div class="tw-flex tw-gap-2">
          <sb-local-date-time-input [ngClass]="{'alertbox': from && till && from?.value > till?.value}" [initialDate]="from"
                                    [title]="'lang.globals.onAirFrom' |translate"
                                    (modelChange)="changeFrom($event)"></sb-local-date-time-input>
          <sb-local-date-time-input class="mr-2" (modelChange)="changeTill($event)" [title]="'lang.globals.onAirTill' |translate"
                                    [initialDate]="till"></sb-local-date-time-input>
        </div>
        <div *ngIf="from && till && from?.value > till?.value" class="alert alert-danger"
             style="font-size: .7rem;">{{ 'lang.globals.dateWarning'|translate }}
        </div>
      </div>


      <!--
      <sb-local-date-range-input class="mr-2" [today]="null" (dateChange)="handleDateChange($event)"></sb-local-date-range-input>

      <div class="mr-2">
      <div id="from-box" (click)="changeFrom()" class="cursor-pointer btn btn-outline-primary">
        &nbsp;&nbsp;{{getFrom()}} &nbsp;<fa-icon [icon]="'chevron-up'"></fa-icon>
      </div>
    </div>
    <div class="mr-2">
      <div id="till-box" (click)="changeTill()" class="cursor-pointer btn btn-outline-primary">
        &nbsp;&nbsp;{{getTill()}} &nbsp;<fa-icon [icon]="'chevron-up'"></fa-icon>
      </div>
      </div>-->

      <sb-comp-dropdown-select
        *ngPermissions="permissionService.Permission.medium_list"
        [inputData]="media" [dropDownDatatype]="'MEDIA'"
        (selectedDataEmitter)="update($event, 'MEDIA')" [showColumnIcon]="false"
        [msOptions]="msMediaOptions" (msOptionsChange)="msRequest('MEDIA', $event)"
        [selectedInputData]="filteredMedia?.length> 0  ? filteredMedia: []">
      </sb-comp-dropdown-select>


      <sb-comp-dropdown-select
        [inputData]="advertisers" [dropDownDatatype]="'ADVERTISERS'"
        (selectedDataEmitter)="update($event, 'ADVERTISERS')" [showColumnIcon]="false"
        [msOptions]="msAdvertiserOptions" (msOptionsChange)="msRequest('ADVERTISERS', $event)"
        [selectedInputData]="filteredAdvertisers?.length>0 ? filteredAdvertisers : []">
      </sb-comp-dropdown-select>
      <sb-comp-dropdown-select
        *ngPermissions="permissionService.Permission.booking_list"
        [inputData]="bookings" [dropDownDatatype]="'BOOKINGS'"
        (selectedDataEmitter)="update($event, 'BOOKINGS')" [showColumnIcon]="false"
        [msOptions]="msBookingsOptions" (msOptionsChange)="msRequest('BOOKINGS', $event)"
        [selectedInputData]="filteredBookings?.length>0 ? filteredBookings : []">
      </sb-comp-dropdown-select>

      @if (!isInDeviceContext) {
        <div>
          <input id="screen-box" type="text" class="form-control" placeholder="{{'lang.globals.screen' | translate}}"
                 [(ngModel)]="screen" (ngModelChange)="requestDebounced()" [ngModelOptions]="{standalone: true}" />
        </div>
        <div>
          <input id="device-box" type="text" class="form-control" placeholder="{{'lang.globals.device' | translate}}"
                 [(ngModel)]="device" (ngModelChange)="requestDebounced()" [ngModelOptions]="{standalone: true}" />
        </div>
      }
      <div class="d-inline-block" ngbDropdown placement="bottom-right">
        <sb-button classes="btn-hover-primary" ngbDropdownToggle>
          <sb-icon icon="ellipsis"></sb-icon>
        </sb-button>
        <div ngbDropdownMenu>
          <ul class="dropdown">
            <li *ngPermissions="permissionService.Permission.device_export_playout" class="item">
              <sb-button (click)="export(false)" [disabled]="loading()" [loading]="loading()"
                         classes="dropdown-item item-link">
                <sb-icon icon="download" class="tw-mr-1"></sb-icon>
                {{ 'lang.globals.export' | translate }}
              </sb-button>
            </li>
            <li *ngPermissions="permissionService.Permission.device_export_playout" class="item">
              <sb-button (click)="export(true)" [disabled]="loading()" [loading]="loading()"
                         classes="dropdown-item item-link">
                <sb-icon icon="download" class="tw-mr-1"></sb-icon>
                {{ 'lang.globals.exportWithDetails' | translate }}
              </sb-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.medium' |translate }}</th>
      <th>{{ 'lang.globals.firstPlayout' |translate }}</th>
      <th>{{ 'lang.globals.lastPlayout' |translate }}</th>
      <th>{{ 'lang.globals.advertiser' |translate }}</th>
      @if (!isInDeviceContext) {
        <th>{{ 'lang.globals.channel' |translate }}</th>
        <th>{{ 'lang.globals.devices' |translate }}</th>
      }
      <th class="tw-text-right">{{ 'lang.globals.actions' |translate }}</th>
    </tr>
  </ng-template>

  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-descriptor>
    <tr>
      <td>
        <sb-comp-image-name-wrapper [medium]="descriptor?.booking?.medium" [customWidth]="'70px'" [customHeight]="'70px'"
                                    [thumbnailSize]="'XS'"
                                    [still]="true">
          <sb-comp-link
            firstLine class="cursor-pointer"
            [title]="descriptor?.booking?.medium?.name | truncate : 23"
            [permission]="permissionService.Permission.medium_list"
            [tooltip]="'lang.globals.openDetails' | translate"
            [link]="util.RoutingID.mediumExplorer" [pathParams]="[{id: 'mediumID', value: descriptor?.booking?.medium?.id}]"
          >
          </sb-comp-link>
          @if (descriptor?.booking?.medium?.duration) {
            <div secondLine class="m-0"> {{ descriptor?.booking?.medium?.duration }}s</div>
          }
        </sb-comp-image-name-wrapper>
      </td>
      <td>{{ descriptor?.firstPlayout?.toString() | date: 'dd.MM.yy HH:mm' }}</td>
      <td>{{ descriptor?.lastPlayout?.toString() | date: 'dd.MM.yy HH:mm' }}</td>
      <td>
        <sb-comp-image-name-wrapper [image]="descriptor?.booking?.advertiser?.logo?.url" [customWidth]="'70px'" [customHeight]="'70px'"
                                    [thumbnailSize]="'XS'"
                                    [still]="true">
          <div firstLine [innerHTML]="descriptor?.booking?.advertiser?.name | truncate : 23"></div>
        </sb-comp-image-name-wrapper>
      </td>
      @if (!isInDeviceContext) {
        <td>
          <sb-comp-image-name-wrapper [image]="descriptor?.booking?.channel?.logo?.url" [customWidth]="'70px'" [customHeight]="'70px'"
                                      [thumbnailSize]="'XS'"
                                      [still]="true">
            <div firstLine [innerHTML]="descriptor?.booking?.channel?.name | truncate : 23"></div>
          </sb-comp-image-name-wrapper>
        </td>
        <td>
          <sb-comp-link
            firstLine class="cursor-pointer"
            [title]="('lang.globals.device' | translate) +' '+ descriptor?.device?.id"
            [permission]="permissionService.Permission.device_show"
            [tooltip]="'lang.globals.openDetails' | translate"
            [link]="util.RoutingID.deviceDetailsOverview" [pathParams]="[{id: 'deviceID', value: descriptor?.device?.id}]"
          >
          </sb-comp-link>
        </td>
      }
      <td class="tw-text-right">
        <button
          sb-button-primary
          type="button"
          (click)="exportPlayouts(descriptor)"
          [ngbTooltip]="'lang.globals.exportPlayoutsForDescriptor' | translate "
          container="body"
          color="blue"
          icon="download"
          [iconButton]="true"
        >
        </button>
      </td>
    </tr>
  </ng-template>
  <!--------------------------------------

  No Card Template

  --------------------------------------->
</sb-table-wrapper>
